
    @if (showProductionWarning) {
      <div
        class="fixed inset-x-0 top-0 z-[1000] bg-danger-700 px-3 py-1.5 text-center
               font-mono text-xs font-bold tracking-wide text-white shadow-lg"
        role="alert"
      >
        {{ KEYS.productionDataLiveWarning | transloco }}
      </div>
    }
    <router-outlet />
    <uv-cookie-consent-banner />
    <uv-toast-container />
    @defer (on idle) {
      <app-developer-fab />
      <app-feedback-report-drawer-host />
      <app-dev-accounts-drawer />
      <app-provet-rate-limits-panel-host />
      <app-developer-context-panel-host />
      <app-client-impersonation-panel-host />
    }
